import { Spinner } from "@humanex/ui/components";

export function LoadingPage() {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-primary-50 gap-4">
      <Spinner className="w-6 h-6" />
      <div className="text-primary text-responsive-lg font-medium">Đang tải...</div>
    </div>
  );
}
